import { useNavigate, useParams } from "react-router-dom";
import Loading from "shared/components/Spin";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { TEMPLATES } from "utils/api/graphql/queries/templates";
import { SCREENS } from "utils/constants";
import View from "./View";

const Detail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.TEMPLATES.LIST.path);
  const [updateTemplate] = useMutation(graphql.mutations.UPDATE_TEMPLATE, {
    refetchQueries: [
      {
        query: TEMPLATES,
        awaitRefetchQueries: true,
      },
    ],
    onCompleted: () => {
      navigate(SCREENS.PRIVATE.ADMIN.TEMPLATES.LIST.path);
    },
    onError: () => {},
  });
  const { data, loading, error } = useQuery(graphql.queries.TEMPLATE, {
    variables: { where: { id } },
  });
  const onSubmit = (data) => {
    return updateTemplate({
      variables: {
        where: {
          id,
        },
        data,
      },
    });
  };

  if (loading || error) return <Loading />;

  return <View onSubmit={onSubmit} data={data.template} cancel={cancel} />;
};

export default Detail;
